import { render, staticRenderFns } from "./asdfzqj.vue?vue&type=template&id=c5d05d6c&"
import script from "./asdfzqj.vue?vue&type=script&lang=js&"
export * from "./asdfzqj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports